import React from 'react';
import { Dropdown, MenuProps } from 'antd';
import { ArrowDownIcon, CheckCircleIcon } from 'icons'; // make sure CheckCircleIcon is imported
import { useTranslations } from 'next-intl';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

const TypeFilterDropdown = () => {
  const t = useTranslations();

  // const [type, setType] = useQueryParam('type', withDefault(StringParam, 'all'));
  const [query, setQuery] = useQueryParams({ type: withDefault(StringParam, 'all'), page: NumberParam });

  const typeLabelMap = {
    all: t('barchasi'),
    public: t('davlat'),
    private: t('xususiy')
  };

  const handleMenuClick: MenuProps['onClick'] = e => {
    setQuery({
      type: e.key === 'all' ? undefined : e.key,
      page: undefined
    });
  };

  const items: MenuProps['items'] = [
    {
      key: 'all',
      label: (
        <div className="flex items-center justify-between">
          {t('barchasi')}
          {query.type === 'all' && <CheckCircleIcon size="18" />}
        </div>
      )
    },
    {
      key: 'public',
      label: (
        <div className="flex items-center justify-between">
          {t('davlat')}
          {query.type === 'public' && <CheckCircleIcon size="18" />}
        </div>
      )
    },
    {
      key: 'private',
      label: (
        <div className="flex items-center justify-between">
          {t('xususiy')}
          {query.type === 'private' && <CheckCircleIcon size="18" />}
        </div>
      )
    }
  ];

  return (
    <Dropdown
      trigger={['click']}
      dropdownRender={menu => <div className="w-40">{menu}</div>}
      placement="bottomRight"
      menu={{ items, onClick: handleMenuClick }}
      className="!rounded-xl"
    >
      <div className="flex items-center bg-white py-2 px-3 sm:px-2 sm:py-1 gap-2 rounded-lg border border-gray-300 text-sm text-gray-600 cursor-pointer">
        {typeLabelMap[query.type as 'all' | 'public' | 'private']}
        <ArrowDownIcon />
      </div>
    </Dropdown>
  );
};

export default TypeFilterDropdown;
